import _ from 'lodash';

export default _.curry(function clamp(min, max, number) {
  return Math.max(Math.min(number, max), min);
});



// WEBPACK FOOTER //
// ./src/util/clamp.js